import { render, staticRenderFns } from "./Orizon.html?vue&type=template&id=18bea240&external"
import script from "./Orizon.vue?vue&type=script&lang=js"
export * from "./Orizon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports